import { Container } from "react-bootstrap";
import './deviceDetails.scss'
import './global.scss'
function LinkErrorScreen(props) {
 return (
  <Container fluid className="p-0 m-0 g-0" style={{ backgroundColor: '#FFFFFF', height: "100%" }}>
   <div style={{ display: 'flex', width: '100%', height: '80%', alignItems: 'center', justifyContent: 'center' }}>
    <div style={{ fontSize: '30px', fontWeight: 'bold', padding: '20px', textAlign: 'center' }}>No Data Found</div>
   </div>
  </Container>
 );
}
export default LinkErrorScreen;